import { AfterViewInit, Component, TemplateRef, ViewChild, inject } from '@angular/core';
import { UnableEmailsModalComponent } from '@components/unable-emails-modal/unable-emails-modal.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AbilityService } from 'ability';
import { I18NextPipe } from 'angular-i18next';
import { Alert, AlertService, ButtonComponent, MbsPopupType, MbsSize, ModalService } from 'mbs-ui-kit';
import { PermissionsEnum } from 'mbs-ui-shared@models';
import { AppPersistentStateService } from 'mbs-ui-shared@services/app-persistent-state.service';
import { NotificationServerSettingsService } from 'mbs-ui-shared@services/notification-server-settings.service';

@UntilDestroy()
@Component({
  selector: 'mbs-unable-deliver-emails-alert',
  templateUrl: './unable-deliver-emails-alert.component.html',
  imports: [ButtonComponent, I18NextPipe]
})
export class UnableDeliverEmailsAlertComponent implements AfterViewInit {
  private notificationService = inject(NotificationServerSettingsService);
  private alertService = inject(AlertService);
  private modalService = inject(ModalService);
  private appStorage = inject(AppPersistentStateService);
  private abilityService = inject(AbilityService);

  @ViewChild('alertTemplate', { static: true }) alertTemplate: TemplateRef<any>;

  protected readonly MbsSize = MbsSize;

  ngAfterViewInit(): void {
    this.abilityService.can('read', PermissionsEnum.Notification) &&
      this.notificationService
        .getBounceListLength()
        .pipe(untilDestroyed(this))
        .subscribe((count) => {
          if (count && this.appStorage.data.showAlertAboutBounceList) {
            queueMicrotask(() =>
              this.alertService
                .alert(
                  new Alert({
                    content: this.alertTemplate,
                    ignoreRouteChanges: true,
                    id: 'unable-deliver-emails',
                    type: MbsPopupType.danger
                  })
                )
                .subscribe(() => {
                  this.appStorage.data.showAlertAboutBounceList = false;
                })
            );
          }
        });
  }

  public showDetails() {
    this.modalService.openCustom(UnableEmailsModalComponent, {
      size: MbsSize.xl
    });
  }
}
